export enum AggregationFunctionEnum {
  SUM = 'sum',
  AVERAGE = 'avg'
}
